<template>
  <div class="middle cadfm-flexitem-stretched">
    <action-panel>
      <action-bar>
        <b-navbar-nav>

          <action-button @click="back" icon="back" bold :text="lang.button_Back"
            :title="lang.button_Back" :disabled="backButtonStatus"/>
          <action-button v-if="isNew" @click="createPhysical" icon="new" bold :text="lang.button_NewPhysical"
            :title="lang.button_NewPhysical" :disabled="createPhysicalButtonStatus"/>
          <action-button v-if="!isNew" @click="updatePhysical" icon="save" bold :text="lang.button_UpdatePhysical" :title="lang.button_UpdatePhysical"
              :disabled="updatePhysicalButtonStatus" />
          
          



        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <action-button v-show="!$parent.isVisibleLeft" @click="toggleLeftPanel" icon="show" bold :text="lang.button_Left"
            :title="lang.button_Left" :disabled="toggleButtonStatus"/>
          <action-button v-show="!$parent.isVisibleRight" @click="toggleRightPanel" icon="show" bold :text="lang.button_Right"
            :title="lang.button_Right" :disabled="toggleButtonStatus"/>

        </b-navbar-nav>
      </action-bar>
      <action-content>
        <Content   :lang="lang.Content"></Content>
      </action-content>
    </action-panel>
  </div>
</template>

<script>
  import ActionBar from '@/components/shared/ActionBar'
  import ActionButton from '@/components/shared/ActionButton'
  import ActionContent from '@/components/shared/ActionContent'
  import ActionPanel from '@/components/shared/ActionPanel'


  import Content from "@/components/PartManager/Views/PartPhysicals/Middle/Content/Content"

//import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

export default {
  name: 'Middle',
  components:{
    ActionBar,
    ActionButton,
    ActionContent,
    ActionPanel,
    Content

  },
  props:{
    lang: Object
  },

  data () {
    return {
      toggleButtonStatus: false,
      createPhysicalButtonStatus: false,
      updatePhysicalButtonStatus: false,
      
      backButtonStatus: false,
      imported: false,
      buttonStatus: 0,
      mainTable: ""
    }
  },
  computed:{
    isNew() {
      return this.$route.query.source == "new";
    },
    distributorPartId(){
      return this.$route.query.distributorPartId
    }
  },
  created() {

    
  },
  watch: {
    

  },
  methods: {
    createPhysical(){
      

      
      this.mainTable
        .search("")
        .draw(); 


      let vue = this;

      const obj = {
        
      }


      let new_part_main = document.getElementsByClassName("new-part-main");
      for (let i = 0, lei = new_part_main.length; i < lei; i++){
        
        if (new_part_main[i].dataset.type == "LeadDaysText" && new_part_main[i].dataset.type == "AvailableQuantityText"){
          obj[new_part_main[i].dataset.type] = parseInt(new_part_main[i].value);
        } else {
          if (new_part_main[i].dataset.type == "DistributorName") {
            obj['InformationSource'] = new_part_main[i].value;
          } else {
            

            obj[new_part_main[i].dataset.type] = new_part_main[i].value;
            
          }
          
        }
        
        
        
      }

      const properties = [];
      
      let new_part_props_name = document.getElementsByClassName("new-part-props-name");
      let new_part_props_value = document.getElementsByClassName("new-part-props-value");
      for (let i = 0, lei = new_part_props_name.length; i < lei; i++){
        let tempName = new_part_props_name[i].id.split("__");
        let indexName = tempName[1];
        let value = "";
        
        let name = new_part_props_name[i].value;
        
        for (let j = 0, lej = new_part_props_value.length; j < lej; j++){
          let tempValue = new_part_props_value[j].id.split("__");
          let indexValue = tempValue[1];
          if (indexName == indexValue){
            value = new_part_props_value[j].value;
            break;
          }
        }
        
        const objProps = {
          Name: name,
          Value: [value],
          Type: 0
        }
        properties.push(objProps)

        
      }

      const priceArray = [];

      let new_part_price_quantity = document.getElementsByClassName("new-part-price-quantity");
      let new_part_price_price = document.getElementsByClassName("new-part-price-price");
      let new_part_price_currency = document.getElementsByClassName("new-part-price-currency");
      
      for (let i = 0, lei = new_part_price_quantity.length; i < lei; i++){
        let tempMinQuantity = new_part_price_quantity[i].id.split("__");
        let indexQuantity = tempMinQuantity[1];
        let price = "";
        let currency = "";
        
        let minQuantity = new_part_price_quantity[i].value;
        
        for (let j = 0, lej = new_part_price_price.length; j < lej; j++){
          let tempPrice = new_part_price_price[j].id.split("__");
          let indexPrice = tempPrice[1];
          if (indexQuantity == indexPrice){
            price = new_part_price_price[j].value;
            break;
          }
        }
        for (let j = 0, lej = new_part_price_currency.length; j < lej; j++){
          let tempCurrency = new_part_price_currency[j].id.split("__");
          let indexCurrency = tempCurrency[1];
          if (indexQuantity == indexCurrency){
            currency = new_part_price_currency[j].value;
            break;
          }
        }

        let a = parseInt(minQuantity);
        let b = parseFloat(price);
        

        if (isNaN(a) || isNaN(b)) {
          
          let obj = {
            text: vue.lang.alert_error_CreatePhysical + ": " + vue.lang.alert_error_NumberValidation,
            time: 15,
            type: "danger"
          }

          this.$store.dispatch("displayFooterAlert", obj);
          return;
        }
        
        const objPrice = {
          MinQuntity: a,
          Price: b,
          Currency: currency
        }
        
        priceArray.push(objPrice)

      
      }

      obj.properties = properties
      obj.prices = priceArray
      obj.alternatePackagings = [ null ]

      
      const o = {
        physical: [obj] 
      }

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_createPhysical", o)
      .then ((result) => {

       console.log(result)

        if (result.status == "OK"){

          if (result.data.distributorPartId != undefined){
            let obj = {
              text: vue.lang.alert_success_CreatePhysical,
              time: 10,
              type: "success"
            }

            vue.$store.dispatch("displayFooterAlert", obj);

            if (this.$store.getters.selectedRows.length > 0) {
              let objExt = {
                  partId: this.$store.getters.selectedRows[0].col___revisionId.partId,
                  alternatives: [{ distributorPartId: result.data.distributorPartId }]
                }

                vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_assignPhysicals", objExt)
                  .then((result) => {

                    console.log(result)

                    if (result.status == "OK") {

                    }

                  })
            }
            


            const reloadObj = {
                status: true,
                name: "DataTableFilteredOnApiComponent"
            }
            vue.$store.dispatch("reloadAfterAction", reloadObj);

          }else{
            let obj = {
              text: vue.lang.alert_error_CreatePhysical + ": " + result.message,
              time: 15,
              type: "danger"
            }

            vue.$store.dispatch("displayFooterAlert", obj);
          }
          
        }else{
          let obj = {
              text: vue.lang.alert_error_CreatePhysical + ": " + result.message,
              time: 15,
              type: "danger"
            }

            vue.$store.dispatch("displayFooterAlert", obj);
        }


     })


    },
    updatePhysical() {

      let vue = this;

      const obj = {

      }


      let new_part_main = document.getElementsByClassName("new-part-main");
      for (let i = 0, lei = new_part_main.length; i < lei; i++) {

        if (new_part_main[i].dataset.type == "LeadDaysText" && new_part_main[i].dataset.type == "AvailableQuantityText") {
          obj[new_part_main[i].dataset.type] = parseInt(new_part_main[i].value);
        } else {
          if (new_part_main[i].dataset.type == "DistributorName") {
            obj['DistributorName'] = new_part_main[i].value;
            obj['InformationSource'] = new_part_main[i].value;
          } else {
            

            obj[new_part_main[i].dataset.type] = new_part_main[i].value;
            
          }

        }


      }

      const properties = [];

      let new_part_props_name = document.getElementsByClassName("new-part-props-name");
      let new_part_props_value = document.getElementsByClassName("new-part-props-value");
      for (let i = 0, lei = new_part_props_name.length; i < lei; i++) {
        let tempName = new_part_props_name[i].id.split("__");
        let indexName = tempName[1];
        let value = "";

        let name = new_part_props_name[i].value;

        for (let j = 0, lej = new_part_props_value.length; j < lej; j++) {
          let tempValue = new_part_props_value[j].id.split("__");
          let indexValue = tempValue[1];
          if (indexName == indexValue) {
            value = new_part_props_value[j].value;
            break;
          }
        }

        const objProps = {
          Name: name,
          Value: [value],
          Type: 0
        }
        properties.push(objProps)


      }

      const priceArray = [];

      let new_part_price_quantity = document.getElementsByClassName("new-part-price-quantity");
      let new_part_price_price = document.getElementsByClassName("new-part-price-price");
      let new_part_price_currency = document.getElementsByClassName("new-part-price-currency");
      for (let i = 0, lei = new_part_price_quantity.length; i < lei; i++) {
        let tempMinQuantity = new_part_price_quantity[i].id.split("__");
        let indexQuantity = tempMinQuantity[1];
        let price = "";
        let currency = "";

        let minQuantity = new_part_price_quantity[i].value;

        for (let j = 0, lej = new_part_price_price.length; j < lej; j++) {
          let tempPrice = new_part_price_price[j].id.split("__");
          let indexPrice = tempPrice[1];
          if (indexQuantity == indexPrice) {
            price = new_part_price_price[j].value;
            break;
          }
        }
        for (let j = 0, lej = new_part_price_currency.length; j < lej; j++) {
          let tempCurrency = new_part_price_currency[j].id.split("__");
          let indexCurrency = tempCurrency[1];
          if (indexQuantity == indexCurrency) {
            currency = new_part_price_currency[j].value;
            break;
          }
        }

        let a = parseInt(minQuantity);
        let b = parseFloat(price);


        if (isNaN(a) || isNaN(b)) {

          let obj = {
            text: vue.lang.alert_error_UpdatePhysical + ": " + vue.lang.alert_error_NumberValidation,
            time: 15,
            type: "danger"
          }

          this.$store.dispatch("displayFooterAlert", obj);
          return;
        }

        const objPrice = {
          MinQuntity: a,
          Price: b,
          Currency: currency
        }

        priceArray.push(objPrice)


      }

      obj.properties = properties
      obj.prices = priceArray
      obj.alternatePackagings = [null]


      const o = {
        physical: [obj],
        distributorPartId: this.distributorPartId
      }

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_updatePhysical", o)
        .then((result) => {

          console.log(result)

          if (result.status == "OK") {

            if (result.data == 1) {
              let obj = {
                text: vue.lang.alert_success_CreatePhysical,
                time: 10,
                type: "success"
              }

              vue.$store.dispatch("displayFooterAlert", obj);

              // let objExt = {
              //   partId: this.$store.getters.selectedRows[0].col___revisionId.partId,
              //   alternatives: [{ distributorPartId: result.data.distributorPartId }]
              // }

              // vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_assignPhysicals", objExt)
              //   .then((result) => {

              //     console.log(result)

              //     if (result.status == "OK") {

              //     }

              //   })


              // const reloadObj = {
              //   status: true,
              //   name: "DataTableFilteredOnApiComponent"
              // }
              // vue.$store.dispatch("reloadAfterAction", reloadObj);

            } else {
              let obj = {
                text: vue.lang.alert_error_UpdatePhysical + ": " + result.message,
                time: 15,
                type: "danger"
              }

              vue.$store.dispatch("displayFooterAlert", obj);
            }

          } else {
            let obj = {
              text: vue.lang.alert_error_UpdatePhysical + ": " + result.message,
              time: 15,
              type: "danger"
            }

            vue.$store.dispatch("displayFooterAlert", obj);
          }


        })
      
    },
    
    back(){

      let to = this.$route.query.from;
      
           

      const query = {
        from: this.$route.path,
        to: to,

      }
      if (to == "/PartManager/PartDetails") {
        query.revisionId = this.$route.query.revisionId;
        query.id = this.$route.query.id;
      }
console.log(to,query)
      this.$router.push({ path: to, query: query }); 
    },
    toggleRightPanel(){
      
      this.$parent.isVisibleRight = !this.$parent.isVisibleRight;
      
    },
    toggleLeftPanel(){
      
      this.$parent.isVisibleLeft = !this.$parent.isVisibleLeft;
      
    }
  }
}
</script>


<style scoped>

  .middle{
    border-right: 1px solid #666;
  }

</style>



// WEBPACK FOOTER //
// src/components/PartManager/Views/PartPhysicals/Middle/Middle.vue